import React from 'react';

import { useCommonStore } from '../../../stores/commonStore';
import { Option } from '../../../types/common';

interface CheckBoxWithTextProps {
    id: string;
    label: string;
    fsnArInfo: Option;
    shouldDisable3DinPP?: boolean;
}

const CheckBoxWithText = ({ id, label, fsnArInfo, shouldDisable3DinPP = false }: CheckBoxWithTextProps) => {
    const setFSNModelMetaData = useCommonStore((state) => state.setFSNModelMetaData);

    const { hidden, value: checked, disabled: fsnArInfoDisabled } = fsnArInfo.meta[id];
    const disabled = shouldDisable3DinPP || fsnArInfoDisabled;

    const handleOnChange = () => {
        setFSNModelMetaData(id, !checked);
    };

    return (
        <>
            {!hidden ? (
                <div className="flex justify-center items-center">
                    <input
                        checked={checked}
                        id={id}
                        type="checkbox"
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        disabled={disabled}
                        onChange={handleOnChange}
                    />
                    <label htmlFor={id} className="ml-2 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                        {label}
                    </label>
                </div>
            ) : null}
        </>
    );
};

export default React.memo(CheckBoxWithText);
